import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";

import {
    collection,
    query,
    where,
    getDocs,
    setDoc,
    doc,
    onSnapshot,
    deleteDoc
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import logo_default from "../../assets/logo_default.jpg";
import CopyUID from "../../components_root/copyuid";
import { Toast } from '../../components_root/ToastContext';
import { MdOutlineVerifiedUser, MdClose } from "react-icons/md";
import "../../body_root/popup.css";

export default function Ledger_account_profile_popup({ data, isOpen, onClose }) {

    const panelRef = useRef(null);
    const { Toastshow } = Toast();
    const navigate = useNavigate(); 

    const [IsLoading2, setIsLoading2] = useState(true);
 
    const [account_data, setAccount_data] = useState([]);
    const [accountguid, setaccountguid] = useState();
    const servicetablename = "companies";
    useEffect(() => {
        setaccountguid(data);
    }, [data]);
    const fetch_accounts = () => {
        if (!accountguid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        const ledgerQuery = query(
            collection(db, servicetablename, select_company_uid, "staff_accounts"),
            where("accountguid", "==", accountguid)
        );

        const unsubscribe = onSnapshot(
            ledgerQuery,
            async (snapshot) => {

                // ✅ if companies/staff_accounts has data
                if (!snapshot.empty) {

                    const ledgerDocs = snapshot.docs;

                    const mergedData = await Promise.all(
                        ledgerDocs.map(async (docSnap) => {
                            const ledgerData = { id: docSnap.id, ...docSnap.data() };

                            const accountDoc = await getDocs(
                                query(
                                    collection(db, "accounts"),
                                    where("guid", "==", accountguid)
                                )
                            );

                            let accountInfo = {};
                            if (!accountDoc.empty) {
                                accountInfo = {
                                    account_id: accountDoc.docs[0].id,
                                    ...accountDoc.docs[0].data(),
                                };
                            }

                            return {
                                ...ledgerData,
                                account_info: accountInfo
                            };
                        })
                    );

                    setAccount_data(mergedData);
                    setIsLoading2(false);
                    return;
                }

                // ✅ ELSE: fallback to accountingfinancedb/ledger_accounts
                const fallbackQuery = query(
                    collection(db, "accountingfinancedb", select_company_uid, "ledger_accounts"),
                    where("accountguid", "==", accountguid)
                );

                const fallbackSnap = await getDocs(fallbackQuery);

                const mergedData = await Promise.all(
                    fallbackSnap.docs.map(async (docSnap) => {
                        const ledgerData = { id: docSnap.id, ...docSnap.data() };
                        return {
                            ...ledgerData,
                            account_info: ledgerData
                        };
                    })
                );

                setAccount_data(mergedData);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching accounts:", error);
                setIsLoading2(false);
            }
        );

        return unsubscribe;
    };


    useEffect(() => {
        fetch_accounts();
    }, [accountguid]);
    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    return (
        <div className={`div-popup-body ${isOpen ? "show" : ""}`}>
            <div ref={panelRef} className={`overflow-auto div-panel-right ${isOpen ? "slide-in" : "slide-out"}`}>

                <div className="b-bottom items-back">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="button-ui0 text-h2 bold p-2 fcap">
                                        <MdOutlineVerifiedUser className="icon" />
                                        Profile  
                                    </div>
                                </td>
                                <td width={30}>
                                    <div onClick={onClose} className="button-ui0 p-2 cursor">
                                        <MdClose className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="p-2">
                    {IsLoading2 ? null : account_data.length === 0 ? (
                        <div className="text-h2 bold p-5">No Print Found</div>
                    ) : (
                        account_data.map((row) => (
                            <div className="m-1" key={row.id}>
                           
                                <img
                                    src={row.account_info?.photoURL || 
                                                logo_default}
                                    alt="logo"
                                    className="brand-thumbnail"
                                         onError={(e) => {
                                            e.currentTarget.src = logo_default;
                                        }}
                                />

                                <table className="b-bottom">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div
                                                    className={
                                                        ` text-h3 fcap bold ` +
                                                        (account_data[0]?.account_type === "cashier" ? "button-ui red-back" : "button-ui2")
                                                    }
                                                >
                                                    {account_data[0]?.account_type.replaceAll("_", " ")}
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    className="button-ui0 bold"
                                                    style={{
                                                        color: row.status ? "green" : "red",
                                                    }}
                                                >
                                                    {row.status ? "Activate" : "Deactivate"}
                                                </div>
                                            </td>
                                            <td width={130} className="text-h3 text-r">
                                                {row.date_time?.toDate ? (
                                                    <>
                                                        {row.date_time
                                                            .toDate()
                                                            .toLocaleDateString()}{" "}
                                                        {row.date_time
                                                            .toDate()
                                                            .toLocaleTimeString()}
                                                    </>
                                                ) : (
                                                    <div className="contact-details">No date</div>
                                                )}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="text-h3 text-off">Account No.</td>
                                            <td>{account_data[0]?.accountnumber || "N/A"}</td>
                                            <td width={30}><CopyUID id={account_data[0]?.accountnumber} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="fcap">
                                    <tbody>
                                        {[
                                            ["Name", row.account_info?.name],
                                            ["Email", row.account_info?.email],
                                            ["Mobile", row.account_info?.mobile],
                                            ["City", row.account_info?.city],
                                            ["Post Code", row.account_info?.postcode],
                                            ["State", row.account_info?.state],
                                            ["Country", row.account_info?.country],
                                        ].map(([label, value]) => (
                                            <tr key={label}>
                                                <td className="text-h3 text-off">{label}</td>
                                                <td className="text-h3">{value || "N/A"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        ))
                    )}
                </div> 
            </div>
        </div>
    );
}
